<template>
  <div class="px-4 py-14 sm:px-6 lg:px-8">
    <div class="w-full max-w-2xl mx-auto space-y-10 sm:mt-0 sm:h-auto">
      <!-- Congratulations -->
      <div class="p-4 bg-white rounded-lg dark:bg-gray-900 sm:p-8">
        <div class="justify-center block text-center">
          <v-icon
            name="bi-trophy"
            scale="1.5"
            class="w-16 h-16 p-2 mx-auto text-yellow-700 bg-yellow-300 border-2 border-yellow-100 rounded-full shadow-sm border-3 animate__delay-1s animate__animated animate__flip shadow-yellow-300 sm:mt-0"
          />

          <div class="mt-5 space-y-5 text-center text-gray-900 dark:text-white sm:text-lg">
            <p class="items-center">
              Content review for<span class="mx-1 font-semibold">{{ today }}</span
              >successfully completed.
            </p>
            <p class="mx-1">{{ reviewCompleteMessage }}</p>

            <div class="flex items-center justify-center mx-auto space-x-4">
              <template v-if="shareTitle">
                <ShareButton :align="'left'" :buttonSize="'md'" :title="shareTitle" :description="shareDescription" />
              </template>
              <router-link
                to="/progress"
                class="inline-flex items-center px-3 py-2 font-medium text-gray-800 capitalize border border-transparent rounded-md shadow text-md bg-slate-100 hover:bg-slate-200"
              >
                Check your progress
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Share sources -->
      <div v-if="sharingSources.length">
        <h3 class="mb-3 text-lg font-bold leading-6 text-gray-900 capitalize dark:text-gray-50 sm:text-xl">Share Your Content</h3>
        <div class="p-4 bg-white rounded-lg dark:bg-gray-900 sm:p-8">
          <div>
            <template v-for="(source, index) in sharingSources" :key="index">
              <div
                class="py-3"
                :class="{
                  'border-b': index != sharingSources.length - 1,
                  'pb-0': index == sharingSources.length - 1,
                  'pt-0': index == 0,
                }"
                v-if="source.image"
              >
                <div class="flex items-center justify-between">
                  <div class="flex-shrink-0 mr-4">
                    <img :src="source.image" class="object-cover rounded-md h-9 w-9 sm:h-10 sm:w-10" />
                  </div>

                  <div class="flex-grow">
                    <h4 class="text-sm text-left text-gray-900 sm:text-md line-clamp-2 dark:text-white">{{ source.title }}</h4>
                  </div>
                  <div class="ml-2 place-self-center">
                    <ShareButton :align="'right'" :buttonSize="'sm'" :url="source.url" :title="`${source.title}`" :description="source.description" />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import ShareButton from "../components/ShareButton.vue";
import utilFunctions from "../composables/util";
import { getAuth } from "firebase/auth";
import { onBeforeMount } from "@vue/runtime-core";

export default {
  components: {
    ShareButton,
  },
  props: ["sources"],
  setup(props) {
    const { getUser } = utilFunctions();
    const reviewCompleteMessages = ["Congratulations!", "You're on your way!", "Great job!", "Good work, well done!", "Keep it up!", "You're doing great!", "Well done!"];
    const reviewCompleteMessage = reviewCompleteMessages[Math.floor(Math.random() * reviewCompleteMessages.length)];

    const sharingNetworks = [
      {
        name: "Twitter",
        icon: "bi-twitter",
      },
      {
        name: "Email",
        icon: "co-gmail",
      },
      {
        name: "Messenger",
        icon: "bi-messenger",
      },
      {
        name: "WhatsApp",
        icon: "bi-whatsapp",
      },
      {
        name: "Facebook",
        icon: "bi-facebook",
      },
      {
        name: "LinkedIn",
        icon: "bi-linkedin",
      },

      {
        name: "Reddit",
        icon: "bi-reddit",
      },
    ];

    const sourceList = ref(props.sources);

    const today = ref(new Date().toLocaleString("en-US", { month: "long", day: "numeric" }));

    const sharingSources = sourceList.value.filter((source, index, self) => {
      return self.findIndex((t) => t.url === source.url) === index;
    });

    const userData = ref({});
    const shareTitle = ref("");
    const shareDescription = ref("");

    const auth = getAuth();

    onBeforeMount(async () => {
      userData.value = await getUser(auth.currentUser.uid);

      const shareTitlePartOne = `${today.value} review completed. 💪 🧠`;
      const shareTitlePartTwo = userData.value?.reviews?.streak ? `\nReview streak: ${userData.value?.reviews?.streak}\n` : "";

      shareTitle.value = shareTitlePartOne + shareTitlePartTwo;
      shareDescription.value = "Try Wisery https://wisery.io today and see how you can improve your knowledge.";
    });

    return {
      reviewCompleteMessage,
      sharingSources,
      sharingNetworks,
      shareTitle,
      shareDescription,
      today,
    };
  },
};
</script>
